// Unpublished Work © 2025 Deere & Company.

import {datadogLogger} from '@deere/datadog-action-logger';
import {get} from '../../common/utils/config';
import {APP_LOAD, APP_LOAD_STEP} from '../constants/datadogActionConstants';

const ddEnvironments = ['qual', 'cert', 'prod'];

export function isValidEnvironment() {
    const env = get<string>('NODE_ENV');

    return ddEnvironments.includes(env);
}

export function startAppLoadTracking() {
    datadogLogger.startTracking(APP_LOAD, [APP_LOAD_STEP], {
        enabled: isValidEnvironment(),
    });
    datadogLogger.recordActionStepStart(APP_LOAD, APP_LOAD_STEP);
}

export function startActionTracking(action: string, steps: string[]) {
    datadogLogger.startTracking(action, steps, {
        enabled: isValidEnvironment(),
    });
}

export function startStep(action: string, step: string) {
    datadogLogger.recordActionStepStart(action, step);
}
export function completeStep(action: string, step: string, metadata?: object) {
    datadogLogger.recordActionStepCompleted(action, step, metadata);
}
export function recordActionMetadata(action: string, metadata: object) {
    datadogLogger.recordActionMetadata(action, metadata);
}
